module.exports = __webpack_public_path__ + "img/product-image.90ae6270.png";